"use client";
import { Link } from "@/navigation";
import { CloudArrowUp } from "@phosphor-icons/react";
import { useTranslations } from "next-intl";

export default function GetInstantQuoteButton() {
	const t = useTranslations("newBanner");
	return (
		<Link
			href="/upload"
			className="group font-semibold inline-flex hover:text-white items-center justify-center gap-2 rounded bg-themePrimary400 px-4 py-2.5 text-sm text-white transition-all duration-300 hover:bg-opacity-80 sm:px-5 sm:py-3 md:px-6 md:py-3.5 md:text-base"
		>
			<CloudArrowUp className="h-4 w-4 md:h-[18px] md:w-[18px]" weight="fill" />
			{t("getInstantQuote")}
		</Link>
	);
}
